export const GRUPOS = Object.freeze({
  OISOL_MASTER: "OISOL_MASTER",
});

const ALIAS_OISOL_MASTER = ["OISOL_MASTER", "OISOL.MASTER", "OISOL MASTER"];

function normalizarGrupo(valor) {
  if (typeof valor !== "string") return "";
  return valor.trim().toUpperCase().replace(/[.\s]/g, "_");
}

function extrairNomesGrupo(user) {
  const valores = []
    .concat(user?.grupos || [])
    .concat(user?.groups || [])
    .concat(user?.grupo || [])
    .filter(Boolean);

  return valores
    .map((item) => {
      if (typeof item === "string") return item;
      return item?.nome || item?.name || item?.group || item?.grupo || null;
    })
    .filter(Boolean);
}

export function isOisolMaster(user) {
  if (!user) return false;
  return extrairNomesGrupo(user).some((nome) =>
    ALIAS_OISOL_MASTER.map(normalizarGrupo).includes(normalizarGrupo(nome))
  );
}

export function podeGerenciarIntegracaoDenuncia(user) {
  return isOisolMaster(user);
}

export function podeGerenciarMenuIndicador(user) {
  return isOisolMaster(user);
}
